import { render, staticRenderFns } from "./SeletorImagem.vue?vue&type=template&id=760f77be&scoped=true"
import script from "./SeletorImagem.vue?vue&type=script&lang=js"
export * from "./SeletorImagem.vue?vue&type=script&lang=js"
import style0 from "./SeletorImagem.vue?vue&type=style&index=0&id=760f77be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760f77be",
  null
  
)

export default component.exports